import { useLoadableReferenceData } from "../../hooks/useReferenceData";

export const PreloadReferenceData = () => {
  useLoadableReferenceData();
  return null;
};

export default PreloadReferenceData;
